// (c) chaehongee. Confidential and proprietary.

import { formatRelativeTime as formatRelativeTimeIntl } from '../i18n/formatters'

/**
 * Format a datetime string to locale-aware relative time
 * (e.g., "2 days ago" in English, "2일 전" in Korean)
 */
export function formatRelativeTime(isoDateString: string): string {
  return formatRelativeTimeIntl(isoDateString)
}
